import React, {Component, Fragment} from "react";
import moment from "moment";
import {Modal as ModalRs, ModalBody, ModalHeader} from "reactstrap";
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import {pageNumber} from "../../../functions/functionGeneral";
import Paging from "../../paging";
import {Empty, Spin, Tooltip} from "antd";
import {connect} from "react-redux";
import {APIKEY} from "../../../helper/host";
import ElipsisIcon from "../../../assets/icons/ellipsis-vertical.svg";

export class DeviceKaryawan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            modal: false,
            pageCount: 0,
            perPage: 0,
            currentPage: 0,
            paginate: 10,
            totalData: 0,
            lat: "",
            lng: "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    handlePageClick(data) {
        let selected = data.selected;
        this.setState({ currentPage: selected, loading: true }, () => {
            this.loadData();
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }

    loadData() {
        this.setState({ loading: true })
        let form = {
            paginate: 5,
            page: this.state.currentPage + 1,
            id: this.props.match.params.karyawan_slug
        }
        this.props.request('karyawan/get-device-karyawan-v2', form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        data: response.data.data,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                    })
                }
                this.setState({
                    loading: false
                })
            })
    }

    componentDidMount() {
        this.loadData()
    }

    render() {
        let no = 0;
        return (
            <Fragment>
                <ModalRs size='lg' isOpen={this.state.modal} toggle={() => this.setState({ modal: false })}>
                    <ModalHeader style={{ backgroundColor: "#FAFDFF" }} toggle={() => this.setState({ modal: false })}>Detail Lokasi</ModalHeader>
                    <ModalBody>
                        <div style={{
                            position: 'relative',
                            width: '100%',
                            height: '250px'
                        }}>
                            <Map google={this.props.google}
                                 initialCenter={{
                                     lat: this.state.lat,
                                     lng: this.state.lng
                                 }}
                                 zoom={15}>
                                <Marker />
                            </Map>
                        </div>
                    </ModalBody>
                </ModalRs>

                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <div className="d-flex justify-content-between" style={{
                                display: "flex", alignItems: "center", justifyContent: "space-between"
                            }}>
                                <h5>Daftar device karyawan</h5>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            {!this.state.loading && this.state.data.length === 0 ?
                                <Empty description="Data Kosong"
                                       image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" />
                                :
                                <table className="table mb-5">
                                    <thead>
                                    <tr>
                                        <th className="lembur-th-style">#</th>
                                        <th className="lembur-th-style">Alamat Ip</th>
                                        <th className="lembur-th-style">Sistem Operasi</th>
                                        <th className="lembur-th-style">Versi Sistem Operasi</th>
                                        <th className="lembur-th-style">Model Perangkat</th>
                                        <th className="lembur-th-style">Waktu Login Terakhir</th>
                                        <th className="lembur-th-style">Latitude Lokasi Login</th>
                                        <th className="lembur-th-style">Longitude Lokasi Login</th>
                                        <th className="lembur-th-style"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading &&
                                            <tr>
                                                <td colSpan={8}>
                                                    <Spin size="large" tip="Loading..." style={{
                                                        width: '100%',
                                                        margin: 'auto',
                                                        marginBottom: '10px',
                                                        marginTop: '10px'
                                                    }} />
                                                </td>
                                            </tr>
                                        }
                                        {this.state.data.map((item) => {
                                            no += 1
                                            return (
                                                <tr style={{backgroundColor: item.contract_status === 'active' ? '#e9ffd7' : '#fff'}}>

                                                    <td className="lembur-td-style">{pageNumber(no, this.state.perPage, this.state.currentPage)}</td>
                                                    <td className="lembur-td-style">{item.device_ip}</td>
                                                    <td className="lembur-td-style">{item.device_os}</td>
                                                    <td className="lembur-td-style">{item.device_os_version}</td>
                                                    <td className="lembur-td-style">{item.device_model}</td>
                                                    <td className="lembur-td-style text-center">
                                                        <div>
                                                            <span style={{
                                                                fontWeight: 400,
                                                                fontSize: "14px",
                                                                lineHeight: "24px",
                                                                color: "#143B5E"
                                                            }}>
                                                                {moment(item.device_created_at).format('HH:mm:ss')}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span style={{
                                                                fontWeight: 400,
                                                                fontSize: "14px",
                                                                lineHeight: "24px",
                                                                color: "#143B5E"
                                                            }}>
                                                                {moment(item.device_created_at).format('LL')}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td className="lembur-td-style">{item.device_login_latitude}</td>
                                                    <td className="lembur-td-style">{item.device_login_longitude}</td>
                                                    <td className="lembur-td-style text-center">
                                                        <Tooltip trigger={'click'} zIndex={100} placement="bottom"
                                                                 color={'#fff'} title={
                                                            <div className={'p-2'}>
                                                                <a onClick={() => {
                                                                    this.setState({
                                                                        modal: true,
                                                                        lat: item.device_login_latitude,
                                                                        lng: item.device_login_longitude
                                                                    })
                                                                }} className={'text-dark'}>Lihat Pin Lokasi</a><br/>
                                                            </div>
                                                        }>
                                                            <button className='dk-btn'>
                                                                <img alt='' src={ElipsisIcon}/>
                                                            </button>
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            }
                            <Paging
                                className="float-right"
                                handlePageClick={this.handlePageClick}
                                pageCount={this.state.pageCount}
                                currentPage={this.state.currentPage}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user
})

export default connect(mapStateToProps)(GoogleApiWrapper({
    apiKey: APIKEY
})(DeviceKaryawan));